import { FC } from 'react';
import { Field } from 'react-final-form';
import { Borrower } from '../../../interfaces/borrower';
import 'react-toastify/dist/ReactToastify.css';

type Props = {
  profile?: Borrower | null;
};

const ProfileInformationComponent: FC<Props> = ({ profile }) => {
  return (
    <>
      <h3 className='fw-bolder text-dark mb-3'>Personal Information</h3>
      <div className='row'>
        <div className='mb-5 col-lg-6'>
          <label className='form-label mb-3'>First Name</label>
          <Field name='firstname' type='text'>
            {({ input }) => (
              <>
                <div className='mb-3'>
                  <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                </div>
              </>
            )}
          </Field>
        </div>

        <div className='mb-5 col-lg-6'>
          <label className='form-label mb-3'>Last Name</label>
          <Field name='lastname' type='text'>
            {({ input }) => (
              <>
                <div className='mb-3'>
                  <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>

      <div className='mb-2 col-lg-12'>
        <label className='form-label'>Address</label>
        <Field name='address' type='text'>
          {({ input }) => (
            <>
              <div className='mb-3'>
                <input type='text' {...input} placeholder='Address' className='form-control form-control-lg form-control-solid' readOnly />
              </div>
            </>
          )}
        </Field>
      </div>

      <div className='mb-2 col-lg-12'>
        <label className='form-label'>City</label>
        <Field name='city' type='text'>
          {({ input }) => (
            <>
              <div className='mb-3'>
                <input type='text' {...input} placeholder='City' className='form-control form-control-lg form-control-solid' readOnly />
              </div>
            </>
          )}
        </Field>
      </div>

      <div className='row'>
        <div className='mb-2 col-lg-6'>
          <label className='form-label'>State/Province</label>
          <Field name='state' type='text'>
            {({ input }) => (
              <>
                <div className='mb-3'>
                  <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                </div>
              </>
            )}
          </Field>
        </div>
        <div className='mb-2 col-lg-6'>
          <label className='form-label'>Country</label>
          <Field name='country' type='text'>
            {({ input }) => (
              <>
                <div className='mb-3'>
                  <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>

      <h3 className='fw-bolder text-dark mt-5 mb-5'>Work Information</h3>
      <div className='row'>
        <div className='mb-5 col-lg-6'>
          <label className='form-label mb-3'>Occupation</label>
          <Field name='occupation' type='text'>
            {({ input }) => (
              <>
                <div className='mb-3'>
                  <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                </div>
              </>
            )}
          </Field>
        </div>
        <div className='mb-5 col-lg-6'>
          <label className='form-label mb-3'>Employment Type</label>
          <Field name='employment_type'>
            {({ input }) => (
              <>
                <div className='mb-3'>
                  <select {...input} className='form-select form-select-lg form-select-solid' disabled>
                    <option value='true'>Self Employed</option>
                    <option value='false'>Employed</option>
                  </select>
                </div>
              </>
            )}
          </Field>
        </div>
      </div>
      {profile?.is_self_employed ? (
        <>
          <div className='mb-5 col-lg-12'>
            <Field name='business_name' type='text'>
              {({ input }) => (
                <>
                  <label className='form-label'>Business Name</label>
                  <div className='mb-3'>
                    <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                  </div>
                </>
              )}
            </Field>
          </div>

          <div className='mb-2 col-lg-12'>
            <label className='form-label'>Business City</label>
            <Field name='business_city' type='text'>
              {({ input }) => (
                <>
                  <div className='mb-3'>
                    <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                  </div>
                </>
              )}
            </Field>
          </div>

          <div className='row'>
            <div className='mb-2 col-lg-6'>
              <label className='form-label'>Business State/Province</label>
              <Field name='business_state' type='text'>
                {({ input }) => (
                  <>
                    <div className='mb-3'>
                      <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                    </div>
                  </>
                )}
              </Field>
            </div>
            <div className='mb-2 col-lg-6'>
              <label className='form-label'>Business Country</label>
              <Field name='business_country' type='text'>
                {({ input }) => (
                  <>
                    <div className='mb-3'>
                      <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                    </div>
                  </>
                )}
              </Field>
            </div>
          </div>

          <div className='row'>
            <div className='mb-5 col-lg-6'>
              <label className='form-label'>RC Number</label>
              <Field name='rc_no' type='text'>
                {({ input }) => (
                  <>
                    <div className='mb-3'>
                      <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                    </div>
                  </>
                )}
              </Field>
            </div>

            <div className='mb-5 col-lg-6'>
              <label className='form-label'>Job Title/Position?</label>
              <Field name='job_title' type='text'>
                {({ input }) => (
                  <>
                    <div className='mb-3'>
                      <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                    </div>
                  </>
                )}
              </Field>
            </div>
          </div>

          <div className='row'>
            <div className='mb-5 col-lg-6'>
              <label className='form-label'>Nature of Business</label>
              <Field name='business_type' type='text'>
                {({ input }) => (
                  <>
                    <div className='mb-3'>
                      <input type='text' placeholder='Business Type' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                    </div>
                  </>
                )}
              </Field>
            </div>

            <div className='mb-5 col-lg-6'>
              <label className='form-label'>Years in Operation</label>
              <Field name='business_duration' type='text'>
                {({ input }) => (
                  <>
                    <div className='mb-3'>
                      <input type='number' placeholder='in years' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                    </div>
                  </>
                )}
              </Field>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='mb-5 col-lg-12'>
            <Field name='employer_name' type='text'>
              {({ input }) => (
                <>
                  <label className='form-label  text-capitalize'>Employer Name</label>
                  <div className='mb-3'>
                    <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                  </div>
                </>
              )}
            </Field>
          </div>

          <div className='mb-2 col-lg-12'>
            <label className='form-label'>Employer City</label>
            <Field name='employer_city' type='text'>
              {({ input }) => (
                <>
                  <div className='mb-3'>
                    <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                  </div>
                </>
              )}
            </Field>
          </div>

          <div className='row'>
            <div className='mb-2 col-lg-6'>
              <label className='form-label'>Employer State/Province</label>
              <Field name='employer_state' type='text'>
                {({ input }) => (
                  <>
                    <div className='mb-3'>
                      <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                    </div>
                  </>
                )}
              </Field>
            </div>
            <div className='mb-2 col-lg-6'>
              <label className='form-label'>Employer Country</label>
              <Field name='employer_country' type='text'>
                {({ input }) => (
                  <>
                    <div className='mb-3'>
                      <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                    </div>
                  </>
                )}
              </Field>
            </div>
          </div>

          <div className='row'>
            <div className='mb-5 col-lg-6'>
              <label className='form-label text-capitalize'>Job Title</label>
              <Field name='job_title' type='text'>
                {({ input }) => (
                  <>
                    <div className='mb-3'>
                      <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly />
                    </div>
                  </>
                )}
              </Field>
            </div>

            <div className='mb-5 col-lg-6'>
              <label className='form-label text-capitalize'>Employment Duration</label>
              <Field name='employment_duration' type='number'>
                {({ input }) => (
                  <>
                    <div className='mb-3'>
                      <input type='number' {...input} placeholder='In Years' className='form-control form-control-lg form-control-solid' readOnly />
                    </div>
                  </>
                )}
              </Field>
            </div>
          </div>
        </>
      )}

      <h3 className='fw-bolder text-dark mt-5 mb-5'>Other Information</h3>
      <div className='mb-5 col-lg-12'>
        <Field name='linkedin' type='text'>
          {({ input }) => (
            <>
              <label className='form-label'>Linkedin Profile</label>
              <div className='mb-3'>
                <input type='text' placeholder='Optional' {...input} className='form-control form-control-lg form-control-solid' readOnly />
              </div>
            </>
          )}
        </Field>
      </div>
      <div className='row'>
        <div className='mb-5 col-lg-6'>
          <Field name='bvn' type='text'>
            {({ input }) => (
              <>
                <label className='form-label'>BVN</label>
                <div className='mb-3'>
                  <input type='text' placeholder='Optional' {...input} className='form-control form-control-lg form-control-solid' />
                </div>
              </>
            )}
          </Field>
        </div>

        <div className='mb-5 col-lg-6'>
          <Field name='nin' type='text'>
            {({ input }) => (
              <>
                <label className='form-label'>NIN</label>
                <div className='mb-3'>
                  <input type='text' placeholder='Optional' {...input} className='form-control form-control-lg form-control-solid' />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>

      {(profile?.income_prove || profile?.work_prove) && (
        <>
          <h3 className='fw-bolder text-dark mt-5 mb-5'>Supporting Documents</h3>
          <div className='row'>
            {profile.income_prove && (
              <div className='mb-5 col-lg-6'>
                <label className='form-label'>Proof of Income</label>
                <div>
                  <a href={profile.income_prove} className='btn btn-light btn-sm d-block' rel='noreferrer' target='_blank'>
                    View Document
                  </a>
                </div>
              </div>
            )}

            {profile.work_prove && (
              <div className='mb-5 col-lg-6'>
                <label className='form-label'>Proof of Work or Business</label>
                <div>
                  <a href={profile.work_prove} className='btn btn-light btn-sm d-block' rel='noreferrer' target='_blank'>
                    View Document
                  </a>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default ProfileInformationComponent;
